import { IState } from '../store';

export const rootStateBranchSelector =
  <RootStateBranchName extends keyof IState>(rootStateBranchName: RootStateBranchName) =>
  (state: IState): IState[RootStateBranchName] =>
    state[rootStateBranchName];
